module.exports = __webpack_public_path__ + "static/media/Conexie-4.620c442c.webp";